import { memoize } from 'lodash';
import { createSelector } from 'reselect';
import { State } from '.';
import { EncounterPatientEducation } from '../../models/encounter-patient-education';

const getEncounterPatientEducationIdsSelector = createSelector(
    (state: State) => state.byId,
    (byId: Dictionary<EncounterPatientEducation>) => memoize((
        appointmentId: Undefinable<number>
    ) => Object
        .keys(byId)
        .filter(x => appointmentId && byId[x]!.appointmentId === appointmentId)
        .map(x => +x)
        .sort((a, b) => a - b)
    )
);

export const selectors = {
    getEncounterPatientEducation: (
        state: State,
        id: Undefinable<number>
    ): Undefinable<EncounterPatientEducation> => state.byId[id || ''],
    getEncounterPatientEducationIds: (
        state: State,
        id: Undefinable<number>
    ): number[] => getEncounterPatientEducationIdsSelector(state)(id),
    getLoading: (
        state: State,
        loadingKey: string
    ): boolean => state.loading[loadingKey] || false
};
